function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#abb8c3",
  d: "M83.423,41.738c-1.255-9.453-6.469-16.346-12.895-16.346H40.805c-6.43,0-11.641,6.894-12.9,16.342 c-4.522,2.343-6.863,7.127-6.863,12.666c0,4.114,1.298,7.808,3.81,10.396v9.188H36.53v-5.379h38.266v5.381h11.679v-9.186 c2.514-2.592,3.812-6.284,3.812-10.397C90.285,48.865,87.944,44.078,83.423,41.738z M40.805,28.898h29.721 c4.138,0,7.756,4.912,9.11,11.567c-0.634-0.112-1.298-0.178-1.986-0.218c0-0.014,0.005-0.029,0.005-0.044 c0-3.937-3.198-7.137-7.131-7.137c-3.935,0-7.138,3.203-7.138,7.137H34.649c-1.048,0-2.034,0.096-2.966,0.26 C33.045,33.808,36.668,28.898,40.805,28.898z M75.321,40.203h-9.59c0-2.646,2.149-4.801,4.798-4.801 C73.174,35.401,75.321,37.557,75.321,40.203z M33.003,59.014c-2.551,0-4.618-2.06-4.618-4.614c0-2.551,2.066-4.619,4.618-4.619 c2.548,0,4.617,2.063,4.617,4.619C37.621,56.956,35.552,59.014,33.003,59.014z M69.066,58.264H42.26 c-0.642,0-1.168-0.525-1.168-1.168c0-0.644,0.526-1.168,1.168-1.168h26.806c0.644,0,1.168,0.524,1.168,1.168 C70.234,57.741,69.709,58.264,69.066,58.264z M69.066,54.224H42.26c-0.642,0-1.168-0.527-1.168-1.168 c0-0.646,0.526-1.168,1.168-1.168h26.806c0.644,0,1.168,0.522,1.168,1.168C70.234,53.696,69.709,54.224,69.066,54.224z  M78.318,59.014c-2.55,0-4.616-2.06-4.616-4.614c0-2.551,2.066-4.619,4.616-4.619c2.551,0,4.612,2.063,4.612,4.619 C82.93,56.956,80.869,59.014,78.318,59.014z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4292ff",
  d: "M12.922,16.301L0,29.439l12.835,12.544l12.642-0.946l0.268-12.187L12.922,16.301z M20.159,37.151l-1.448-1.406 c-0.822,0.818-1.916,1.427-2.766,1.581l-0.626-1.277c0.843-0.18,1.841-0.666,2.621-1.467c0.988-1.021,1.067-2.277,0.248-3.071 c-0.79-0.764-1.819-0.678-3.279-0.036c-1.995,0.907-3.532,1.17-4.776-0.04c-1.196-1.157-1.278-2.878-0.211-4.41L8.47,25.619 l0.862-0.891l1.395,1.351c0.861-0.832,1.661-1.2,2.305-1.378l0.6,1.275c-0.46,0.136-1.345,0.419-2.234,1.334 c-1.076,1.106-0.82,2.165-0.243,2.718c0.743,0.724,1.632,0.557,3.359-0.194c2.034-0.892,3.504-0.912,4.784,0.328 c1.13,1.101,1.429,2.917,0.243,4.629l1.493,1.446L20.159,37.151z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgAutomotiveCredit = function SvgAutomotiveCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: 80.336,
    height: 76.336,
    viewBox: "0 0 110.287 80.287",
    style: {
      enableBackground: "new 0 0 90.287 90.287"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutomotiveCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automotiveCredit.950487f5.svg";
export { ForwardRef as ReactComponent };